import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { BoxProgrammingHeaederActionsView } from "@/modules/boxProgrammation/components/boxProgrammingHeader/boxProgrammingHeaderActionsView"
import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { ReturnIcon } from "@images/svgIcons/returnIcon"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useCalendar } from "@modules/calendar/hooks/useCalendar"
import { word } from "@modules/core/utils/i18n"
import { useBoxNavigate } from "@modules/navigation/hooks/useBoxNavigate"
import { Path } from "@modules/navigation/routes"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useParams } from "react-router"

type BoxProgrammingHeaderRightViewProps = {
  className?: string
} & React.ComponentProps<"div">

export function BoxProgrammingHeaderRightView({ className, ...props }: BoxProgrammingHeaderRightViewProps) {
  const { boxProgramId } = useParams()
  const boxNavigate = useBoxNavigate()
  const { selectedDate } = useCalendar()
  const canManageSessions = useBoxStaffPermission(BoxStaffPermissions.MANAGE_PROGRAMMING)

  return (
    <div className={cn("flex h-50 flex-col items-start justify-between", className)} {...props}>
      <div className="flex w-full flex-col justify-between gap-3 rounded-4xl bg-surface-foreground p-4">
        <Text fontStyle="TM" className="ml-2">
          {word("box.programmation.activity.viewProgrammation")}
        </Text>
        {/* PERMISSIONS - Head-coach & Coach & Financial permissions denied */}
        {canManageSessions && boxProgramId && (
          <ErrorBoundary
            resetKeys={[boxProgramId]}
            fallback={
              <Text fontStyle="BM" className="text-textDefault-caption">
                {word("global.error.somethingGoneWrong")}
              </Text>
            }
          >
            <Suspense fallback={<LoadingSpinner />}>
              <BoxProgrammingHeaederActionsView boxProgramId={boxProgramId} />
            </Suspense>
          </ErrorBoundary>
        )}
      </div>
      {/* Back to timetable button */}
      <Button
        variant="underline"
        size="sm"
        onClick={() => {
          if (boxProgramId) {
            boxNavigate(Path.Box.ProgrammationDetails(boxProgramId), {
              state: { selectedDate: selectedDate?.toString() ?? "" },
            })
          }
        }}
        className="w-full"
      >
        <ReturnIcon color="currentColor" width={20} height={20} className="text-textDefault-body" />
        {word("box.backToTimetable")}
      </Button>
    </div>
  )
}
